<template>
  <!--  主页-->
  <div class="page-box">
    <!--    头部-->
    <!--    <site-nav></site-nav>-->
    <!--    头部end-->

    <!--    中部-->
    <div class="index-box">
      <div class="nav-box">
        <div class="logo" @click="$router.push('/largescreen')">
          <img src="@/assets/images/logo.png" />
        </div>
        <div class="nav-ul">
          <div
            class="nav-li"
            @click="changes2()"
            :class="{ active: active == 0 }"
          >
            <img src="@/assets/images/1.png" :class="{ hide: active == 0 }" />
            <img src="@/assets/images/3.png" :class="{ hide: active == 1 }" />
          </div>
          <div
            class="nav-li"
            @click="changes()"
            :class="{ active: active == 1 }"
          >
            <img src="@/assets/images/4.png" :class="{ hide: active == 0 }" />
            <img src="@/assets/images/2.png" :class="{ hide: active == 1 }" />
          </div>
        </div>
      </div>
      <div class="index-right">
        <div class="top">
          <div class="left">运行风险源管理及支持系统</div>
          <div class="right">
            <div class="FlightInquire-box">
              <!--              <el-select v-model="flightNO" placeholder="当前航班"  @change="selectFlt">-->
              <!--                <el-option-->
              <!--                  v-for="item in flgtList"-->
              <!--                  :key="item.id"-->
              <!--                  :label="item.flgtno"-->
              <!--                  :value="item.id"-->
              <!--                >-->
              <!--                </el-option>-->
              <!--              </el-select>-->
              <!--输入航班-->
              <div class="FlightInquire-modal hide">
                <div class="FlightInquire-input">
                  <img src="@/assets/images/ss.png" />
                  <el-input placeholder="输入航班号"></el-input>
                </div>
                <div class="FlightInquire-ul">
                  <div class="FlightInquire-li" v-for="(item, index) in 5">
                    <div class="FlightInquire-laber">
                      <div class="FlightInquire-h">CSN6903</div>
                      <div class="FlightInquire-p">3h 23m</div>
                    </div>
                    <div class="icb"></div>
                    <div class="FlightInquire-laber">
                      <div class="FlightInquire-h">CSN6903</div>
                      <div class="FlightInquire-p">3h 23m</div>
                    </div>
                    <img src="@/assets/images/fj.png" />
                    <div class="FlightInquire-laber">
                      <div class="FlightInquire-h">CSN6903</div>
                      <div class="FlightInquire-p">3h 23m</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
<!--            <div class="icon active">
              <img src="@/assets/images/tz.png" />
            </div>-->
            <div class="user-box">
              <img class="headimg" v-if="currentUser && currentUser.avatarUrl" :src="getAvatar(currentUser)" />
              <img class="headimg" v-else src="@/assets/images/logo.png" />
              <div class="user-text">
                <div class="user-h">{{ currentUser.nickname }}</div>
                <div class="user-p">
                  {{
                    currentUser &&
                    currentUser.roleNames &&
                    currentUser.roleNames.length > 0
                      ? currentUser.roleNames[0]
                      : ""
                  }}
                </div>
              </div>
              <!--  <img src="@/assets/images/xiala.png"/>-->
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  <i
                    class="el-icon-arrow-down el-icon--right"
                    style="color: white"
                  ></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="visibleChangePasswordDialog">修改密码</el-dropdown-item>
                  <el-dropdown-item command="loginout">退出</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
        <!--主页-->
        <div class="homepage-box" :class="{ hide: active == 1 }">
          <!--风险评估上报提醒-->
          <el-dialog :visible.sync="dialogVisible3" width="973px">
            <div class="messagepopup-box">
              <div class="messagepopup-head">
                <img src="@/assets/images/logo.png" />
              </div>
              <div class="messagepopup-text">
                <div class="messagepopup-top">
                  <div class="messagepopup-h">杨靖韵 发起了起飞前故障上报</div>
                  <div class="messagepopup-time">现在</div>
                </div>
                <div class="messagepopup-bottom">
                  <video />
                </div>
              </div>
            </div>
          </el-dialog>
          <!--故障弹窗-->
          <el-dialog :visible.sync="dialogVisible" width="973px">
            <div class="messagepopup-box">
              <div class="messagepopup-head">
                <img src="@/assets/images/logo.png" />
              </div>
              <div class="messagepopup-text">
                <div class="messagepopup-top">
                  <div class="messagepopup-h">杨靖韵 发起了起飞前故障上报</div>
                  <div class="messagepopup-time">现在</div>
                </div>
                <div class="messagepopup-bottom">
                  <div class="messagepopup-ul">
                    <div class="messagepopup-li">飞机类型：a330</div>
                    <div class="messagepopup-li">航班号：MU5783</div>
                    <div class="messagepopup-li">
                      飞机编号：B-2350（注册号）/00712（MSN编号）
                    </div>
                    <div class="messagepopup-li">故障信息：{{ msg.msg }}</div>
                  </div>
                  <div class="messagepopup-bt" @click="goMalfunction(msg.id)">
                    进入查看<img src="@/assets/images/y.png" />
                  </div>
                </div>
              </div>
            </div>
          </el-dialog>
          <!--故障弹窗2-->
          <el-dialog
            :visible.sync="dialogVisible2"
            width="724px"
            custom-class="modal2"
          >
            <div class="messagepopup-box">
              <div class="messagepopup-text">
                <div class="messagepopup-top">
                  <div class="messagepopup-head">
                    <img src="@/assets/images/logo.png" />
                  </div>
                  <div class="messagepopup-h">杨靖韵 发起了起飞前故障上报</div>
                </div>
                <div class="messagepopup-bottom">
                  <div class="messagepopup-ul">
                    <div class="messagepopup-li">飞机类型：a330</div>
                    <div class="messagepopup-li">航班号：MU5783</div>
                    <div class="messagepopup-li">
                      飞机编号：B-2350（注册号）/00712（MSN编号）
                    </div>
                    <div class="messagepopup-li">
                      故障信息：AIRPACK 1(2)（3）REGULFAULT
                    </div>
                  </div>
                </div>
              </div>
              <div class="messagepopup-bt">
                进入查看<img src="@/assets/images/y.png" />
              </div>
            </div>
          </el-dialog>
          <!--人员风险源管理-->
          <div class="homepage-top" :class="{ hide:  number !== 0 }">
            <div class="manage-top">
              <div class="manage-left">
                <img src="@/assets/images/icon.png" />
              </div>
              <div class="manage-right">
                <div class="manage-h">人员风险源管理</div>
                <div class="manage-p">
                  飞行员完成故障信息的输入，启动系统识别飞机风险源
                </div>
              </div>
            </div>
            <div class="manage-bottom">
              <div class="manage-li">
                <img src="@/assets/images/t2.png" />
                <div class="manage-p">爆炸物探测报警</div>
              </div>
              <div class="manage-li">
                <img src="@/assets/images/t1.png" />
                <div class="manage-p">客舱扰乱</div>
              </div>
              <div class="manage-li">
                <img src="@/assets/images/t3.png" />
                <div class="manage-p">非法干扰</div>
              </div>
            </div>
            <div class="manage-bt" @click="goKeCang">
              进入系统<img src="@/assets/images/y.png" />
            </div>
          </div>
          <!--飞行故障风险评估-->
          <div class="homepage-top" :class="{ hide:  number !== 1 }">
            <div class="manage-top">
              <div class="manage-left">
                <img src="@/assets/images/icon2.png" />
              </div>
              <div class="manage-right">
                <div class="manage-h">飞行故障风险评估</div>
                <div class="manage-p">针对颠簸等信息的旅客通知及展示</div>
              </div>
            </div>
            <div class="manage-bottom active">
              <div class="assess-box">
                <div class="assess-li">
                  <img src="@/assets/images/pg1.png" />
                </div>
                <div class="assess-li">
                  <img src="@/assets/images/pg2.png" />
                </div>
                <div class="assess-li">
                  <img src="@/assets/images/pg3.png" />
                </div>
                <div class="assess-p">元宇宙运行风险评估，元宇宙超重评估</div>
                <img src="@/assets/images/xian.png" class="xian" />
              </div>
            </div>
            <div class="manage-bt" @click="goFlying">
              进入系统<img src="@/assets/images/y.png" />
            </div>
          </div>
          <!--飞行故障风险评估-->
          <div class="homepage-top" :class="{ hide: number != 2 }">
            <div class="manage-top">
              <div class="manage-left">
                <img src="@/assets/images/icon3.png" />
              </div>
              <div class="manage-right">
                <div class="manage-h">地面运行起飞前故障决策</div>
                <div class="manage-p">
                  飞行员完成故障信息的输入，启动系统识别飞机风险源
                </div>
              </div>
            </div>
            <el-carousel
              :interval="5000"
              arrow="always"
              v-if="errorRecordList.length > 0"
            >
              <el-carousel-item
                v-for="(item, index) in errorRecordList"
                :key="index"
                :value="item"
              >
                <div class="manage-bottom active2">
                  <div class="number-li">
                    <img src="@/assets/images/d1.png" />
                    <div class="number-h">{{ item.flightNo }}</div>
                    <div class="number-p">航班号</div>
                  </div>
                  <div class="number-li">
                    <img src="@/assets/images/d2.png" />
                    <div class="number-h">
                      {{ item.planeId }}/{{ item.msn }}
                    </div>
                    <div class="number-p">注册号/MSN编号</div>
                  </div>
                  <div class="number-li">
                    <img src="@/assets/images/d3.png" />
                    <div class="number-h">{{ item.lastResultComment }}</div>
                    <div class="number-p">最终结论</div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
            <div
              class="manage-bottom task-b"
              v-if="errorRecordList.length === 0"
            >
              <img src="@/assets/images/qq4.png" />
              <div class="p">暂无风险评估申请</div>
            </div>
            <div class="manage-bt" @click="goTask">
              进入系统<img src="@/assets/images/y.png" />
            </div>
          </div>
          <!--飞行故障风险评估-->
          <div class="homepage-top" :class="{ hide:  number != 3 }">
            <div class="manage-top">
              <div class="manage-left">
                <img src="@/assets/images/index-tab3.png" />
              </div>
              <div class="manage-right">
                <div class="manage-h">颠簸风险检测及预警</div>
                <div class="manage-p">针对颠簸等信息的旅客通知及展示</div>
              </div>
            </div>
            <div class="manage-bottom active3">
              <img src="@/assets/images/index-tab3-bottom.png" />
            </div>
            <router-link to="/bumpprevention">
              <div class="manage-bt" style="color:white">
                进入系统<img src="@/assets/images/y.png" />
              </div>
            </router-link>
          </div>
          <div class="homepage-bottom">
            <div class="home_carousel">
              <div
                ref="swiperRef"
                class="swiper-container swiper-container-horizontal"
              >
                <div
                  class="swiper-wrapper"
                  style="transition-duration: 300ms; transform: translate3d(-2780px, 0px, 0px);"
                >
                  <div class="swiper-slide" @click="goKeCang">
                    <img src="@/assets/images/qq2.png" />
                    <div class="swiper-p">人员风险源管理</div>
                  </div>
                  <div class="swiper-slide" @click="goEventinitiation" >
                    <img src="@/assets/images/qq3.png" />
                    <div class="swiper-p">飞行故障风险评估</div>
                  </div>
                  <div class="swiper-slide" @click="goTask">
                    <img src="@/assets/images/qq4.png" />
                    <div class="swiper-p">地面运行起飞前故障决策</div>
                  </div>
                  <div class="swiper-slide" @click="goToBump">
                    <img src="@/assets/images/qq.png" />
                    <div class="swiper-p">颠簸风险检测及预警</div>
                  </div>
                </div>
              </div>

              <div class="swiper-button-prev"></div>
              <div class="swiper-button-next"></div>
            </div>
          </div>
        </div>
        <!--应用程序-->
        <div class="apps-box" :class="{ hide: active == 0 }">
          <div class="apps-h">全部应用</div>
          <div class="apps-ul">
            <div class="apps-li" @click="goTask">
              <img src="@/assets/images/qq4.png">
              <div class="apps-p">地面运行起飞前故障决策</div>
            </div>
            <div class="apps-li" @click="goEventinitiation" >
              <img src="@/assets/images/qq3.png" />
              <div class="apps-p">飞行故障风险评估</div>
            </div>
            <div class="apps-li" @click="goKeCang">
              <img src="@/assets/images/qq2.png" />
              <div class="apps-p">人员风险源管理</div>
            </div>
            <!-- <div class="apps-li active">
              <img src="@/assets/images/qq.png" />
              <div class="apps-p">颠簸风险检测及预警</div>
            </div> -->
            <div class="apps-li" @click="goToBump">
              <img src="@/assets/images/qq.png" />
              <div class="apps-p">颠簸风险检测及预警</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--    页脚-->
    <!--    <footer-bar></footer-bar>-->
    <!--    页脚end-->
    <user-change-password-dialog v-if="visibleChangePasswordDialog" :visible.sync="visibleChangePasswordDialog" @ok="loginout"/>
  </div>
</template>

<script>
import SiteNav from "../../components/base/siteNav";
import FooterBar from "../../components/base/footerBar";
import modal from "../../components/modal";
import Swiper from "swiper";
import {
  pageFltPlan,
  loginOut,
  planeErrorRecordHistory
} from "@/api/api";
import UserChangePasswordDialog from "@/components/UserChangePasswordDialog.vue";
import MixinMqttClient from "@/components/mqtt/MixinMqttClient";

  export default {
    name: "index",
    components: { UserChangePasswordDialog, FooterBar, SiteNav, modal},
    mixins: [MixinMqttClient],
    computed: {
      currentUser() {
        return this.$store.getters.currentUser;
      }
    },
    data() {
      const user = JSON.parse(localStorage.getItem('currentUser'))
      // 是否为模拟机角色
      const hasRoleSIM = user.authorityList.includes('ROLE_SIM')
      console.log(['hasRoleSIM', hasRoleSIM, user.authorityList])
      return {
        role: null,
        options: [{
          value: '1',
          label: 'CSN3412',
        }],
        flgtList: [],
        flight: null,
        flightNO: '',
        swiper: null,
        currentIndex: 0,
        active: 0,
        hasRoleSIM, // 是否为模拟机角色
        number: 0,
        dialogVisible: false,
        dialogVisible2: false,
        dialogVisible3: false,
        msg: {},
        errorRecordList: [],
        visibleChangePasswordDialog: false
      }
    },
    created() {
      this.role = this.currentUser.client
      console.log(["this.currentUser", this.currentUser.listenerNoticeTopicName, this.currentUser]);
      if (this.currentUser.forceChangePassword) {
        this.visibleChangePasswordDialog = true
      }
    },
    mounted() {
      this.initSwiper()
     // this.getFltList()
      this.getPlaneErrorRecord()
    },
    methods: {
      goToBump(){
          this.$router.push('/bumpprevention');
      },
      async getPlaneErrorRecord() {
        const query={"number": 1, "limit": 10}
        const params={"done":false, "orderBy":JSON.stringify([{"name":"id","direction":"DESC"}])}
        const res = await planeErrorRecordHistory(query,params)
        if(res.code === 'A00000' && res.data.length) {
          this.errorRecordList = res.data
        }
      },
      changes() {
        this.active = 1;
      },
      changes2() {
        this.active = 0;
      },
      initSwiper() {
        let vm = this
        this.swiper =
          new Swiper(this.$refs.swiperRef, {
            watchSlidesProgress: false,
            slidesPerView: 'auto',
            centeredSlides: true,
            loop: false,
            loopedSlides: 5,
            activeIndex: 0,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            pagination: {
              // el: '.swiper-pagination',
              //clickable :true,
            },
            on: {
              slideChange: function () {
                vm.number = this.activeIndex
                // console.log(vm.number);
              },
              progress: function (progress) {
                for (let i = 0; i < this.slides.length; i++) {
                  let slide = this.slides.eq(i);
                  let slideProgress = this.slides[i].progress;
                  let modify = 1;
                  if (Math.abs(slideProgress) > 1) {
                    modify = (Math.abs(slideProgress) - 1) * .6 + 1;
                  }
                  let translate = slideProgress * modify * 500 + 'px';
                  let scale = 1 - Math.abs(slideProgress) / 6;
                  let zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
                  // console.log("translate ", translate);
                  slide.transform('translateX(' + translate + ') scale(' + scale + ')');
                  slide.css('zIndex', zIndex);
                  slide.css('opacity', 1);
                  if (Math.abs(slideProgress) > 5) {
                    slide.css('opacity', 0);
                  }
                }
              },
              slideChangeTransitionEnd: function () {
                //切换结束时，告诉我现在是第几个slide
                vm.currentIndex = this.activeIndex;
                // console.log("slideChangeTransitionEnd  ",vm.currentIndex);
              },
              setTransition: function (transition) {
                for (let i = 0; i < this.slides.length; i++) {
                  let slide = this.slides.eq(i)
                  slide.transition(transition);
                }

              }
            }

          })

      },
      goMalfunction(id) {
        if (this.role === 'ROLE_SOC') {
          this.$router.push(`/malfunction/${id}`)
        } else if (this.role === 'ROLE_MECH') {
          this.$router.push(`/malfunctionMech/${id}`)
        } else if (this.role === 'ROLE_SIM') {
          this.$router.push(`/simulator2/${id}`)
        }
      },
    goTask() {
      if (this.flight === null) {
        //  this.$message.warning('先选择航班')
        // return
      }
      // if (this.errorRecordList.length === 1) {
      //   this.goMalfunction(this.errorRecordList[0].id);
      // } else {
      //   this.$router.push(`/task/${this.role}`);
      // }
      this.$router.push(`/task/${this.role}`);
    },
    async getFltList(flgtno) {
      var param = null;
      if (flgtno) {
        param = { flgtno: flgtno };
      }
      const result = await pageFltPlan(1, 10, param);
      if (result.code === "A00000") {
        this.flgtList = result.data;
      } else {
        this.$message.error(result.message);
      }
    },
    selectFlt(id) {
      if (id === "") return;
      this.flight = this.flgtList.filter(i => i.id === id)[0];
    },
    goFlying() {
      if (this.role === 'ROLE_SOC') {
        this.$router.push("/eventinitiation");
      }else if (this.role === 'ROLE_MECH') {
        this.$router.push("/eventinitiation");
      } else if (this.role === 'ROLE_SIM') {
        this.$router.push(`/eventinitiationSIM`)
      }
    },
    handleCommand(command) {
      console.log(command + typeof command);
      if (command === "loginout") {
        this.loginout();
      } else if (command === "visibleChangePasswordDialog") {
        this.visibleChangePasswordDialog=true
      }
    },
    async loginout() {
      const res = await loginOut().then(() => {
        localStorage.removeItem("currentUser");
      });
      this.unsubscribeMQTT(this.mqttUserListenerTopicName);
      this.disconnectMQTT()
      this.$router.push("/login");
    },
    getAvatar(user) {
      return user && user.avatarUrl ? user.avatarUrl : "";
    },
    goKeCang(){
      this.$router.push(`/risksource/${this.role}`);
    },
    goEventinitiation() {
      if (this.role === 'ROLE_SOC') {
        this.$router.push("/eventinitiation");
      }else if (this.role === 'ROLE_MECH') {
        this.$router.push("/eventinitiation");
      } else if (this.role === 'ROLE_SIM') {
        this.$router.push(`/eventinitiationSIM`)
      }
    }
  }
};
</script>
<style lang="css"></style>
<style lang="less" scoped>
  .nav-box{
    height:100vh;
  }
  .index-right{
    height: 100vh;
  }
/deep/ .modal2.el-dialog {
  background: url("~@/assets/images/modal.png") no-repeat;
  background-size: 100% 100%;
  margin-top: 18% !important;

  .messagepopup-box {
    display: block;
  }

  .messagepopup-text {
    width: 100%;
    box-sizing: border-box;
    margin-left: 0;
  }

  .messagepopup-top {
    justify-content: left;

    .messagepopup-h {
      margin-left: 10px;
      color: #fb918b;
    }
  }

  .messagepopup-bottom {
    .messagepopup-ul {
      background: rgba(255, 255, 255, 0.03);
      border-radius: 10px;

      .messagepopup-li {
        color: #ffffff;
        opacity: 0.87;
      }
    }
  }

  .messagepopup-bt {
    background: linear-gradient(
        180deg,
        rgba(19, 25, 43, 0.0001) 73.52%,
        rgba(255, 55, 55, 0.36014) 109.18%
      ),
      linear-gradient(0deg, #52393a 0%, #141c2f 100%);
    backdrop-filter: blur(25.9936px);
    border-radius: 100px;
    width: 138.23px;
    height: 40px;
    line-height: 40px;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    opacity: 0.88;
    font-size: 16px;
    margin: auto;
    margin-top: 24px;
    cursor: pointer;

    img {
      width: 12px;
      margin-left: 10px;
    }
  }
}

/deep/ .el-carousel__container {
  height: 344px;
  background: none;
}

/deep/ .el-carousel__indicators--horizontal {
  bottom: 20px;
}

/deep/ .el-dialog {
  background: rgba(255, 255, 255, 0.77);
  border-radius: 20px;
  margin-top: 32px !important;

  .el-dialog__headerbtn {
    width: 28px;
    height: 28px;
    background: url("~@/assets/images/exit.png") no-repeat;
    background-size: 100% 100%;
    top: -12px;
    right: -12px;

    i {
      display: none;
    }
  }

  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 31px 24px;
  }
}

.home_carousel {
  position: relative;
  width: 100%;
  margin: 0 auto;
  height: 100%;

  .swiper-container {
    width: 100%;
    height: 100%;
    margin-left: -20px;

    .swiper-slide {
      position: relative;
      height: 180px;
      width: 180px;
      background: linear-gradient(
          180deg,
          rgba(19, 25, 43, 0.0001) 79.52%,
          #7e74d8 99.99%
        ),
        linear-gradient(0deg, #262d40 0%, #4e5466 100%);
      border-radius: 50%;
      cursor: pointer;
      padding-top: 40px;
      box-sizing: border-box;
      position: relative;
      margin: 0 60px;

      img {
        width: 54px;
      }

      .swiper-p {
        opacity: 0.8;
        width: 150px;
        margin: auto;
        font-size: 16px;
        line-height: 32px;
      }
    }

    .swiper-slide p {
      font-size: 20px;
    }

    .swiper-slide-active:before {
      content: "";
      display: block;
      width: 260px;
      height: 260px;
      position: absolute;
      background: url("~@/assets/images/1111.png") no-repeat;
      background-size: 100% 100%;
      border-radius: 50%;
      left: -20px;
      top: -20px;
    }

    .swiper-slide:nth-child(2).swiper-slide-active:before {
      background: url("~@/assets/images/1112.png") no-repeat;
      background-size: 100% 100%;
    }

    .swiper-slide:nth-child(3).swiper-slide-active:before {
      background: url("~@/assets/images/1113.png") no-repeat;
      background-size: 100% 100%;
    }

    .swiper-slide:nth-child(2) {
      background: linear-gradient(
          180deg,
          rgba(19, 25, 43, 0.0001) 79.52%,
          #e39461 109.18%
        ),
        linear-gradient(0deg, #262d40 0%, #4e5466 100%);
    }

    .swiper-slide:nth-child(3) {
      background: linear-gradient(
          180deg,
          rgba(19, 25, 43, 0.0001) 79.52%,
          #d4c36e 99.99%
        ),
        linear-gradient(0deg, #262d40 0%, #4e5466 100%);
    }

    .swiper-slide-active {
      height: 220px;
      width: 220px;
      margin-top: 20px;
      padding-top: 45px;
      box-sizing: border-box;

      .swiper-p {
        font-size: 20px;
      }
    }
  }

  .swiper-pagination {
    width: 100%;
    bottom: 20px;
  }

  .swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 0 5px;
    border: 3px solid #fff;
    background-color: #d5d5d5;
    width: 10px;
    height: 10px;
    opacity: 1;
  }

  .swiper-pagination-bullets .swiper-pagination-bullet-active {
    border: 3px solid #00aadc;
    background-color: #fff;
  }

  .swiper-button-prev {
    background: url("~@/assets/images/left.png") no-repeat;
    background-size: 100% 100%;
    width: 40px;
    height: 46px;
    top: 100px;
    left: 25px;
    z-index: 9999;
  }

  .swiper-button-prev:hover {
  }

  .swiper-button-next {
    background: url("~@/assets/images/right.png") no-repeat;
    background-size: 100% 100%;
    width: 40px;
    height: 46px;
    top: 100px;
    right: 25px;
    z-index: 9999;
  }

  .swiper-button-next:hover {
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue